import { ComponentProps, useRef } from "react";
import { getMFEConfig } from "@sunrun/sales-experience-shared";
import { useIframeMessages } from "./common";
import type { IFrame } from "components/atoms/IFrame";

type ProfilePage = "profile" | "srm-profile";

type UseProfileAdapterOptions = {
  page?: ProfilePage;
};

const useProfileAdapter = (
  options: UseProfileAdapterOptions = {}
): ComponentProps<typeof IFrame> => {
  const { page = "profile" } = options;
  const ref = useRef<HTMLIFrameElement | null>(null);
  const config = getMFEConfig("profile", "profile");
  const subPath = page === "srm-profile" ? "/srm-profile" : "";
  const src = `${config.iFrameUrl}${subPath}`;
  useIframeMessages(ref, "Profile", config.containerPath);
  return {
    ref,
    basePath: src,
    src,
    title: config.title,
  };
};

export { useProfileAdapter, type ProfilePage };
